import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export const Hero = () => {
    const { t } = useTranslation();
    
    return (
        <div className="hero py-12 md:py-24">
            <div className="container">
                <h1 className="hero-title max-w-6xl text-4xl md:text-8xl font-bold mb-4">{t('hero.title')}</h1>
                <p className="hero-description sm:text-2xl mb-4">{t('hero.description')}</p>
                <div className="flex gap-2">
                    <NavLink to="/blog" className="btn-primary text-xl px-6 py-2 rounded-sm border text-center w-30">Blog</NavLink>
                    <NavLink to="/contact" className="btn-secondary text-xl px-6 py-2 rounded-sm border text-center w-30">{t('hero.contact')}</NavLink>
                </div>		
            </div>
        </div>
    )
}

